





































































































































































import { Component, Prop, Vue, Watch, } from "@/shared/vuepack";
import { FontType, ManageThemesRequest, ManageThemesResponse, UserPermission } from "@/shared/types";
import { Validator } from "vee-validate";
import * as RouteNames from "@/admin/route-names";
import { useThemeStore } from "@/shared/store/theme";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component({})

export default class ManageTheme extends Vue {
  $validator: Validator;
  @Prop() themeId: number;

  themeStore = useThemeStore();
  rolePermissionsStore = useRolePermissionsStore();

  updateFormInSubmit = false;
  RouteNames = RouteNames;
  isLoaded = false;

  model: ManageThemesRequest = {...this.blankTheme};

  get blankTheme () {
    return {
      themeId: 0,
      themeName: "",
      primaryColor: "",
      secondaryColor: "",
      tertiaryColor: "",
      primaryFontColor: "",
      secondaryFontColor: "",
      tertiaryFontColor: "",
      fontType: FontType.Poppins,
      isButtonColorPrimary: false,
      isNavButtonColorSecondary: false,
      isActive: false
    };
  }

  onSubmitChanges (e: Event) {
    e.preventDefault();
    this.$validator.validateAll()
      .then(isValid => {
        if (this.updateFormInSubmit || !isValid) {
          return;
        }
        this.updateFormInSubmit = true;
        this.doUpdateTheme();
      });
  }

  onResetForm (e: Event) {
     this.model = {...this.blankTheme };
  }

  doUpdateTheme () {
    this.themeStore.updateTheme(this.model)
      .then(() => {
        this.updateFormInSubmit = false;
      });
  }

  @Watch("themeStore.themes", { deep: true })
  onThemeIdChanged () {
    if (!this.themeStore.themes && !this.themeStore.themes.length) {
      return;
    }

    if (!this.themeId) {
      return;
    }

    const theme: ManageThemesResponse = this.themeStore.themeById(this.themeId);

    if (!theme) {
      return;
    }

    this.model = {...theme};
  }

  routeToThemeList () {
    return {name: RouteNames.ManageThemes, params: { page: this.themeStore.pageNumber } };
  }

  mounted (): void {
    this.isLoaded = false;
    this.onThemeIdChanged();
    this.isLoaded = true;
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityManageThemeEdit);
  }
}

